module.exports = __webpack_public_path__ + "img/tile.23d16c2e.svg";